<template>
    <button type="button" class="facebook-signup btn btn-block" @click.stop="login">
        <img :src="require(`@assets/img/facebook-f-${iconColor}.svg`)" alt="Facebook">
        <slot />
    </button>
</template>

<script>
export default {
    name: "FacebookAuth",
    props: {
        iconColor: {
            type: String,
            default: "blue"
        }
    },
    methods: {
        // @see https://developers.facebook.com/docs/reference/javascript/FB.login/v3.2
        login() {
            FB.login(response => {
                if (response.status === "connected") {
                    const accessToken = response.authResponse.accessToken;
                    this.$emit("facebook-login", accessToken);
                } else {
                    console.log("User cancelled login or did not fully authorize.");
                }
            }, {
                scope: "email",
                auth_type: "reauthenticate"
            });
        }
    }
}
</script>

<style lang="scss">
.facebook-signup {
    background-color: #3d579b;
    color: white;
    font-size: 15px;

    @media (max-width: $md) {
        padding: .7rem 0.4rem !important;
    }

    img {
        margin-right: 20px;

        @media (max-width: $md) {
            margin-right: 5px;
        }
    }

    &:hover {
        color: white;
    }
}
</style>
